import React from "react";
import { Element as ScrollAnchorElement } from "react-scroll/modules";
import { useTranslation } from "react-i18next";
import { default as UIStepHeader } from "components/StepHeader";
import { formatUrl } from "hooks/FlowMachine/utils";
import EditIcon from "components/EditIcon/EditIcon";

const StepHeader = ({
  idx,
  totalStepAmount,
  title,
  id,
  isSubmitted,
  isActive,
  isAllowed
}) => {
  const { t } = useTranslation();
  return (
    <>
      {/* Scroll to is done via the StepBody component as it is conditionally rendered
       * depending on route. This component is always rendered
       */}
      <ScrollAnchorElement name={id} />
      <UIStepHeader active={isActive} disabled={!isAllowed}>
        <UIStepHeader.Indicator
          index={idx + 1}
          total={totalStepAmount}
          submitted={isSubmitted}
        />
        <UIStepHeader.Title>{t(title)}</UIStepHeader.Title>{" "}
        {/* Translate becuase a step might have a key as title */}
        {isAllowed && !isActive ? (
          <UIStepHeader.Link to={formatUrl(id)}>
            <EditIcon></EditIcon>
          </UIStepHeader.Link>
        ) : null}
      </UIStepHeader>
    </>
  );
};

export default StepHeader;
